/* global variable */
import Handlebars from "handlebars/dist/handlebars.js";
var HANDLEBAR_TEMPLATE_CACHE = {};

export function serviceNetworkError(container) {
    var data = {
        Errors: {
            GenericErrors: [
                SETTINGS.exceptions.generic
            ]
        }
    }

    displayGenericError(container, data);
}

export function serviceNetworkErrorInModal(container) {
    var data = {
        Errors: {
            GenericErrors: [
                SETTINGS.exceptions.generic
            ]
        }
    }

    displayGenericErrorInModal(container, data);
}

export function displayGenericError(container, formResponse) {
    loadGlobalHandlebars(container, "genericError", formResponse, false);
}

export function displayGenericErrorInModal(container, formResponse) {
    loadGlobalHandlebars(container, "genericError", formResponse, true);
}

export function displayInputErrorMarkup(form, formResponse) {
    if (formResponse && formResponse.Errors && formResponse.Errors.InputErrors) {
        $.each(formResponse.Errors.InputErrors, function(key, value) {
            form.find('input[name="' + key + '"]').addClass('parsley-error');
        });
    }
}

export function loadGlobalHandlebars(container, templateName, data, addModalCloseButton) {

    var url = "/Static/handlebars/" + templateName + ".txt";

    $.ajax(
        {
            url: url,
            type: 'GET',
            complete: function (result, textStatus) {
                if (result.status == 200) {
                    doneHandler(container, result.responseText, data, addModalCloseButton);
                }
            }
        }
    );

    function doneHandler(container, templateSource, data, addModalCloseButton) {

        var errorMessage = "";
        container.addClass('error alert-error');

        if (data.Errors && data.Errors.GenericErrors && data.Errors.GenericErrors.length > 0) {
            for (var i = 0; i < data.Errors.GenericErrors.length; i++) {
                data.Errors.GenericErrors[i] = new Handlebars.SafeString("<h4 style=\"color:#d0103a;margin:0;\">" + data.Errors.GenericErrors[i] + "</h4>");
            }
        } else {
            errorMessage = container.data('errorMessage');
            if (errorMessage !== "") {
                errorMessage = "<h4 style=\"color:#d0103a;margin:0;\">" + new Handlebars.SafeString(errorMessage) + "</h4>";
            }
        }

        var template = Handlebars.compile(templateSource);
        var html = template(data);
        container.html(errorMessage + html);

        if (addModalCloseButton) {
            container.append($('<button class="btn btn-primary close-modal">' + SETTINGS.translations.close + '</button>'));
        }

        container.show();
    }
}